export function canViewFreightControlPanel(user) {
  return user?.permissoes?.freightControl?.isView === true;
}

export function canEditFreightControlFinancial(user) {
  return user?.permissoes?.freightControl?.isEdit === true;
}

export function canViewFreightControlDocuments(user) {
  return user?.permissoes?.freightControlDocuments?.isView === true;
}

export function canViewFreightControlBoleto(user) {
  return user?.permissoes?.freightControlBoleto?.isView === true;
}

export function canManageFreightControlBoleto(user) {
  return user?.permissoes?.freightControlBoleto?.isEdit === true;
}

export function getFreightControlActionPermissions(user) {
  const canViewPanel = canViewFreightControlPanel(user);
  const canEditFinancial = canEditFreightControlFinancial(user);
  const canViewDocuments = canViewFreightControlDocuments(user);
  const canViewBoleto = canViewFreightControlBoleto(user);
  const canManageBoleto = canManageFreightControlBoleto(user);

  return {
    canViewPanel,
    canEditFinancial,
    canViewDocuments,
    canViewBoleto,
    canManageBoleto,
    hasAnyAction:
      canEditFinancial ||
      canViewDocuments ||
      canViewBoleto ||
      canViewPanel,
  };
}
